__turbopack_context__.v({
  "dropzone": "ProfileImageInput-module-scss-module__NRGi3a__dropzone",
  "dropzoneHint": "ProfileImageInput-module-scss-module__NRGi3a__dropzoneHint",
  "withPreview": "ProfileImageInput-module-scss-module__NRGi3a__withPreview",
});
